import { useTranslation } from 'react-i18next'
import { CrossSwapOrderStatus as CrossSwapOrderStatusType } from '@tokenlon/v6-sdk'
import ModalStatus from '../../ModalStatus'
import { APPROVE_STATUS } from '../../ModalStatus/types'
import NormalOrderStatus from '~/components/TradeDetail/components/OrderStatus'
import CrossSwapOrderStatus from '~/components/TradeDetail/components/CrossSwapOrderStatus'
import { TRADE_STATUS, TRADE_TYPE } from '~/components/TradeDetail/types'

interface OrderStatusProps {
  status: TRADE_STATUS | CrossSwapOrderStatusType
  isCrossSwap: boolean
  isUnbroadcast: boolean
}

const OrderStatus: React.FC<OrderStatusProps> = ({
  status,
  isCrossSwap,
  isUnbroadcast,
}) => {
  const { t } = useTranslation()

  // 处理唤起钱包签名确认的状态
  if (isUnbroadcast) {
    return (
      <ModalStatus
        status={APPROVE_STATUS.APPROVING}
        statusText={t('waiting_for_confirm')}
        tradeType={TRADE_TYPE.INSTANT}
      />
    )
  }

  // 处理钱包签名后的状态
  return isCrossSwap ? (
    <CrossSwapOrderStatus status={status as CrossSwapOrderStatusType} />
  ) : (
    <NormalOrderStatus
      status={status as TRADE_STATUS}
      tradeType={TRADE_TYPE.INSTANT}
    />
  )
}

export default OrderStatus
